import { render } from "./LogoHeader.vue?vue&type=template&id=a7ced986&scoped=true"
import script from "./LogoHeader.vue?vue&type=script&lang=js"
export * from "./LogoHeader.vue?vue&type=script&lang=js"

import "./LogoHeader.vue?vue&type=style&index=0&id=a7ced986&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7ced986"]])

export default __exports__